import { Module, Action, Model, store, ApiClient } from './helpers'

interface EmployeeModel {
  id: number
  name: string
}

@Module
class EmployeesModule extends Model<EmployeeModel> {
  @Action async GET_EMPLOYEES() {
    const { data } = await ApiClient.get('/my_client/employees.json')
    this.STORE_ENTITIES(data.employees)
  }

  // [EmployeeGetters.GET_Employee_NAME_BY_ID]: (state: EmployeeState) => (id: number) => {
  //   const Employee = state.entitiesById[id]
  //   if (!Employee) { return '' }
  //   return Employee.name
  // },
}

export const Employees = new EmployeesModule({ store, name: 'Employees' })
